import React from 'react';
import '../style/style.css';
import {AnimationStyles, getTheme, ITheme, mergeStyles, Panel, PanelType, Stack} from '@fluentui/react';

import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import history from '../../history';
import {withTranslation, WithTranslation} from 'react-i18next';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import BookMarkPane from '../../shared/bookMarkPane/bookMarkPane';
import ShortCutPane from './shortCutPane/container';
import {getContractingUnit, getProject} from '../../shared/util';
import TitlePane from '../../shared/titlePane/titlePane';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {
  clearFormData,
  filterInvoiceListPaneData,
  readByInvoiceId,
  readInvoiceDropDownData,
  readInvoiceShortCutPaneData,
  resetIsChange,
  setUid,
} from '../../reducers/invoiceReducer';
import DocumentPane from './documentPane/container';
import ListPane from './listPane/container';
import {
  Invoice,
  invoiceFormData,
  InvoiceListPaneFilter,
  InvoiceShortCutPaneItem,
  ListPaneItem,
} from '../../types/invoice';
import {messageService} from '../../services/messageService';
import ProgressBar from '../../shared/progressBar/progressBar';
import SplitPane, {Pane} from 'react-split-pane';
import CollapseBookMarkPane from '../../shared/collapseBookMarkPane/bookMarkPane';
import {resizerStyle} from '../../shared/customStyle/commonStyles';

export interface State {
  selectedShortCutItem: InvoiceShortCutPaneItem;
  invoiceFilter: InvoiceListPaneFilter;
  projectId: string | null;
  invoiceId: string | null;
  formData: Invoice;
  isClone: boolean;
  redirect: boolean;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  currentActiveSection: string;
  headerFilter: boolean;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  selectedListPaneItemIds: [] | string[];
  hiddenRemoveDialog: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean
  resetLayout: boolean
  collapseBookmarkPane: boolean
  reSizer: number
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  readInvoiceShortCutPaneData: () => void;
  showProgressBar: boolean;
  shortCutPaneFilters: InvoiceShortCutPaneItem[];
  filterInvoiceListPaneData: (filterItem: InvoiceListPaneFilter) => void;
  listPaneItems: ListPaneItem[];
  formData: Invoice;
  setUid: () => void;
  clearUid: () => void;
  clearFormData: () => void;
  resetIsChange: () => void;
  uid: string | null;
  readByInvoiceId: (id: string) => void;
  cloneps: (id: string) => any;
  readInvoiceDropDownData: (projectSequenceCode: string | null) => void;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
}

const contentStyle = mergeStyles({
  height: 'calc(100vh - 250px)!important',
  display: 'flex',
  flexDirection: 'column',
  selectors: {
    '@media(max-width: 1100px)': {
      width: '97.4%',
      height: 'calc(100vh)',
      position: 'absolute',
    },
  },
});

const listStyle = mergeStyles({
  flex: '1 1 auto',
  width: '100%',
  height: 'auto',
  overflowX: 'hidden',
  overflowY: 'auto',
  paddingBottom: '30px',
  marginLeft: '0',
});

class InvoiceMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  isEdit = false;
  theme: ITheme = getTheme();
  subscription: any;
  //this.props.t
  private bookmarkList = [
    {
      id: 1,
      link: 'invoice-header',
      label: this.props.t('invoiceInformation'),
    },
    {
      id: 2,
      link: 'invoice-customer-information',
      label: this.props.t('customerInformation'),
    },
    { id: 3, link: 'invoice-invoice-amount', label: this.props.t('invoice') },
    // {
    //   id: 4,
    //   link: 'history',
    //   label: this.props.t('history'),
    // },
  ];

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedShortCutItem: { key: null, id: null, name: 'All', type: 'all', value: null },
      invoiceFilter: new InvoiceListPaneFilter(),
      selectedListPaneItemIds: [],
      projectId: null,
      invoiceId: null,
      hiddenRemoveDialog: true,
      isClone: false,
      isEdit: false,
      autoSave: false,
      redirect: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      headerFilter: false,
      activeClass: 'grid-righter column-filter-activated',
      bookmarkDivClass: 'bookmark-panel parent collapse',
      currentActiveSection: '1',
      showDetails: false,
      formData: invoiceFormData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: window.innerWidth,
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this._handleClick = this._handleClick.bind(this);
  }

  componentDidMount() {
    this.props.readInvoiceShortCutPaneData();
    this.getListPaneData();
    this.handleUrlChange();
    this._isMounted = true;
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('load', this.updateDimensions);
    if (location.pathname.split('/').pop() === 'new' && this.state.formData && this.state.formData.id === null) {
      this.createNew(true);
    }
    this.setState({
      formData: this.props.formData,
    }, this.handleShowDocumentPane);
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }
        if (data.data.collapseDocumentPane) {
          this.setState({
            reSizer: (this.state.reSizer === 300) ? window.innerWidth / 2 : 300,
            isDrag: (!this.state.isDrag),
            collapseBookmarkPane: (!this.state.collapseBookmarkPane),
            resetLayout: (!this.state.resetLayout),
          });
        }

        if (data.data.reloadList) {
          this.reloadListPaneItem();
        }

        if (data.data.shortCutPaneExpanded) {
          if (this.state.showDetails) {
            this.setState({
              reSizer: window.innerWidth / 2,
              isDrag: false,
              collapseBookmarkPane: false,
              resetLayout: true,
            });
          }
        }

        if (data && data.data && data.data.hasOwnProperty('isLoadingInvoiceData') && data.data.isLoadingInvoiceData) {
          this.setState({ isDisableNewButton: true });
        } else if (data.data.hasOwnProperty('isLoadingInvoiceData') && !data.data.isLoadingInvoiceData) {
          this.setState({ isDisableNewButton: false });
        }
      }
    });
    if (getProject()) {
      let projectId = getProject();
      if (projectId) {
        this.props.readInvoiceDropDownData(projectId);
      }
    } else if (this.props.formData && this.props.formData.projectSequenceCode) {
      this.props.readInvoiceDropDownData(this.props.formData.projectSequenceCode);
    } else {
      this.props.readInvoiceDropDownData(null);
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.match.url !== prevProps.match.url) {
      this.handleUrlChange(prevState.collapseBookmarkPane);
    }
    if (this.props.formData !== prevProps.formData) {
      this.setState({
        formData: this.props.formData,
      });
      if (this.props.formData && this.props.formData.projectSequenceCode) {
        this.props.readInvoiceDropDownData(this.props.formData.projectSequenceCode);
      }
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.state.invoiceFilter != this.props.location.state.invoiceFilter
    ) {
      if (this.props.location.state.invoiceFilter) {
        this.setState(
          {
            invoiceFilter: this.props.location.state.invoiceFilter,
          },
          this.reloadListPaneItem,
        );
      }
    }
  }

  handleUrlChange(collapseBookmarkPane?: boolean) {
    let lastParam = this.props.match.url.split('/').pop();
    let projectId = this.props.match.params.id;
    let invoiceId = this.props.match.params.invoiceId
      ? this.props.match.params.invoiceId
      : null;
    this.setState(
      {
        isEdit: !!this.props.match.params.id,
        projectId: projectId,
        invoiceId: invoiceId,
        isDisableNewButton: invoiceId ? true : false,
        isDrag: false,
        resetLayout: collapseBookmarkPane ? false : true,
        collapseBookmarkPane: collapseBookmarkPane ? true : false,
      }, () => {
        this.handleShowDocumentPane(collapseBookmarkPane);
      });
    if (invoiceId) {
      this.props.readByInvoiceId(invoiceId);
    }
  }

  updateDimensions() {
    if (this._isMounted) {
      this.setState({
        width: window.innerWidth,
      });
      if (this.state.showDetails) {
        if (this.state.width > 1100) {
          this.setState({ showPanel: false });
        } else {
          this.setState({ showPanel: true });
        }
      }
    }
  }

  private handleShowDocumentPane = (collapseBookmarkPane?: boolean) => {
    let invoiceId = this.props.match.params.invoiceId
      ? this.props.match.params.invoiceId
      : null;
    if (invoiceId) {
      if (this.state.width > 1100) {
        this.setState({
          showPanel: false,
          showDetails: true,
          reSizer: collapseBookmarkPane ? 300 : window.innerWidth / 2,
        });
      } else {
        this.setState({
          showPanel: true,
          showDetails: true,
          reSizer: collapseBookmarkPane ? 300 : window.innerWidth / 2,
        });
      }
    } else if (location.pathname.split('/').pop() === 'new') {
      if (this.state.width > 1100) {
        this.setState({ showPanel: false, showDetails: true, reSizer: window.innerWidth / 2 });
      } else {
        this.setState({ showPanel: true, showDetails: true, reSizer: window.innerWidth / 2 });
      }
    } else {
      //this.props.resetFormData();
      this.setState({ showPanel: false, showDetails: false, reSizer: window.innerWidth });
    }
  };

  private handleScroll = (e: any): void => {
    let element = e.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
    }

    let h2Headings = document.getElementsByClassName('proj-detail-block');
    let item = h2Headings[0];
    let tt = 0;

    for (let i = 0; i < h2Headings.length; i++) {
      if (h2Headings[i].getBoundingClientRect().top <= 300) {
        if (tt <= h2Headings[i].getBoundingClientRect().top) {
          tt = h2Headings[i].getBoundingClientRect().top;
          item = h2Headings[i];

          var c = item.id;
          this.setState({ currentActiveSection: c });
        }
      }
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('resize', this.updateDimensions);
    this.subscription.unsubscribe();
    //this.props.resetFormData();
  }

  getListPaneData = () => {
    this.props.filterInvoiceListPaneData(this.state.invoiceFilter);
  };

  private handleSelectedListPaneItem = (
    selectedListPaneItemIds: [] | string[],
  ) => {
    this.setState({
      selectedListPaneItemIds: selectedListPaneItemIds,
      isClone: false,
    });
  };


  private createNew = (create: boolean): void => {
    this.props.clearFormData();
    this.props.setUid();
    let formData: Invoice = {
      id: this.props.uid ? this.props.uid : null,
      invoiceId: null,
      title: null,
      headerTitle: null,
      name: null,
      projectTypeId: null,
      projectType: null,
      invoiceStatusId: null,
      projectStatus: null,
      projectCostId: null,
      projectCompletionDate: null,
      workPeriodFrom: null,
      workPeriodTo: null,
      purchaseOrderNumber: null,
      projectSequenceCode: null,
      totalExcludingTax: null,
      totalIncludingTax: null,
      psId: null,
      historyLog: null,
      isSaved: false,
      date: null,
      isProjectFinished: false,
    };
    this.setState({
      formData: formData,
    });
    history.push(`/CU/${getContractingUnit()}/project/${getProject()}/invoice/new`);
  };

  reloadListPaneItem = () => {
    //
    this.props.resetIsChange();
    setTimeout(() => {
      this.getListPaneData();
    }, 100);
    //this.props.getExcelData();
  };

  private handleActionBarSave = (save: boolean): void => {

  };

  private getDocumentPaneView = () => {
    return (
      <div>
        <Stack
          className="project-list-header right-panel"
          style={{ backgroundColor: 'rgb(255, 255, 255)', paddingRight: 0 }}
          styles={{ root: { width: '100%', paddingRight: 0 } }}
        >
          <TitlePane
            close={true}
            headerTitle={
              this.state.formData ? this.state.formData.title : ''
            }
            collapse={true}
            isCollapse={this.state.collapseBookmarkPane}
          />
          <CommandBarRight
            formData={this.state.formData}
            isLoading={this.props.showProgressBar}
            handleRemove={() => this._handleRemove()}
          />
          <ProgressBar show={this.props.showProgressBar}/>
        </Stack>

        <Stack
          className={`pbs project-detail-list ${(this.state.collapseBookmarkPane && window.innerWidth > 1440) ? 'full-inner-container' : 'inner-container'}   card-container`}
          styles={{
            root: {
              width: '100%',
            },
          }}
        >
          {/*doc*/}
          <Stack
            className={contentStyle}
            horizontalAlign="start"
            verticalAlign="start"
            padding={0}
            gap={0}
            styles={{
              root: {
                width: '100%',
                height: '100%',
              },
            }}
          >
            <Stack
              className={listStyle}
              styles={{
                root: {
                  width: '100%',
                  height: 'auto',
                },
              }}
              verticalFill
              gap={50}
              horizontalAlign="start"
              verticalAlign="start"
              onScroll={this.handleScroll}
            >
              {/*DocumentPane*/}
              <DocumentPane
                isEdit={this.state.isEdit}
                formData={this.state.formData}
                projectId={this.state.projectId}
                isExpand={this.state.collapseBookmarkPane}
              />

            </Stack>
            {this.state.collapseBookmarkPane && window.innerWidth > 1440 ? <CollapseBookMarkPane
              isEdit={this.props.isEdit}
              divClass={this.state.bookmarkDivClass}
              currentActiveSection={this.state.currentActiveSection}
              list={this.bookmarkList}
              toggleBookmark={this._toggleBookmark}
              toggleBookmarkOut={this._toggleBookmarkOut}
            /> : <BookMarkPane
              isEdit={this.props.isEdit}
              divClass={this.state.bookmarkDivClass}
              currentActiveSection={this.state.currentActiveSection}
              list={this.bookmarkList}
              toggleBookmark={this._toggleBookmark}
              toggleBookmarkOut={this._toggleBookmarkOut}
            />}

          </Stack>
        </Stack>
      </div>
    );
  };

  handelFilter = (filter: InvoiceListPaneFilter) => {
    if ((filter.title && filter.title.length >= 3) || filter.title === null) {
      this.setState(
        {
          invoiceFilter: filter,
        },
        this.reloadListPaneItem,
      );
    } else {
      this.setState({
        invoiceFilter: filter,
      });
    }
  };


  handelShortCutPaneFilter = (selectedItem: InvoiceShortCutPaneItem) => {
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  render() {
    const { t } = this.props;
    const animation = mergeStyles(
      this.state.showDetails
        ? AnimationStyles.slideLeftIn400
        : AnimationStyles.slideRightIn400,
    );
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={window.innerWidth / 2}
            defaultSize={(this.state.showDetails) ? window.innerWidth / 2 : window.innerWidth}
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.state.reSizer}
            onDragStarted={() => {
              // this.setState({
              //   isDrag:true,
              //   collapseBookmarkPane:true,
              //   resetLayout:false,
              // })
            }}
            onResizerDoubleClick={() => {

              this.setState({
                reSizer: (this.state.reSizer === 300) ? window.innerWidth / 2 : 300,
                isDrag: (!this.state.isDrag),
                collapseBookmarkPane: (!this.state.collapseBookmarkPane),
                resetLayout: (!this.state.resetLayout),
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: (newSize < window.innerWidth / 2),
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === window.innerWidth / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>
              <Stack horizontal>
                <ShortCutPane
                  projectId={this.state.projectId}
                  shortCutPaneFilters={this.props.shortCutPaneFilters}
                  filter={this.state.invoiceFilter}
                  handelShortCutPaneFilter={(
                    selectedItem: InvoiceShortCutPaneItem,
                  ) => this.handelShortCutPaneFilter(selectedItem)}
                  toggleOverlay={this.state.collapseBookmarkPane}
                  resetLayout={this.state.resetLayout}
                />

                <div className={this.state.activeClass}>
                  <Stack
                    className="project-list-header right-panel"
                    style={{
                      backgroundColor: 'rgb(255, 255, 255)',
                      paddingRight: 0,
                    }}
                    styles={{ root: { width: '100%', paddingRight: 0 } }}
                  >
                    <TitlePane
                      headerTitle={
                        this.state.selectedShortCutItem
                          ? this.state.selectedShortCutItem.name
                          : ''
                      }
                    />
                    <CommandBarLeft
                      createNew={(create: boolean) => this.createNew(create)}
                      selectedItemIds={this.state.selectedListPaneItemIds}
                      isDisableNewButton={this.state.isDisableNewButton}
                    />
                    <ProgressBar show={this.props.showProgressBar}/>
                  </Stack>
                  {/*{JSON.stringify(this.props.loadMsg)}*/}
                  <Stack style={{ alignSelf: 'center' }}>
                    <ListPane
                      projectId={this.state.projectId}
                      loadMsg={this.props.loadMsg}
                      reloadListPaneItem={() => this.reloadListPaneItem()}
                      filter={this.state.invoiceFilter}
                      listPaneItems={this.props.listPaneItems}
                      isDataLoaded={this.props.isDataLoaded}
                      isChange={this.props.isChange}
                      formData={this.state.formData}
                      handelFilter={(filter: InvoiceListPaneFilter) =>
                        this.handelFilter(filter)
                      }
                      handleSelectedListPaneItem={(
                        selectedListItemIds: [] | string[],
                      ) => {
                        this.handleSelectedListPaneItem(selectedListItemIds);
                      }}
                      reSizer={this.state.reSizer}
                    />
                    {/*LIST PANE*/}
                  </Stack>
                </div>
              </Stack>
            </Pane>
            <Pane className={'SplitPane'}>
              {this.state.showDetails &&
              <div
                className={`${animation}`}
                style={{
                  display: this.state.showDetails ? 'block' : 'none',
                  transition: 'all 0.9s linear',
                }}
              >
                {!this.state.showPanel && (
                  <div>{this.getDocumentPaneView()}</div>
                )}
              </div>}
            </Pane>


          </SplitPane>
        </div>
        <Panel
          isOpen={this.state.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('Corporate Product Catalogue')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.getDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={this.state.hiddenRemoveDialog}
          title={t('areyousure')}
          subText={t('You won\'t be able to revert this!')}
          onClickConfirmDialog={this.onRemoveConfirm}
          onClickCancelDialog={this.onRemoveCancel}
          cancelButtonText={t('No, I won\'t!')}
          confirmButtonText={t('Yes, delete it!')}
        />
      </div>
    );
  }

  private _showPanel = () => {
    if (this.state.width <= 1100) {
      this.setState({ showPanel: true });
    }
  };

  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/invoice`);
    } else if (getContractingUnit() && getProject()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/invoice`);
    } else {
      history.push(`/invoice`);
    }
  };

  private hideDocumentPane = () => {
    this.setState({
      resetLayout: true,
    });
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/invoice`);
    } else if (getContractingUnit() && getProject()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/invoice`);
    } else {
      history.push(`/invoice`);
    }
  };

  private _handleClick(): void {
    if (this.state.headerFilter == false) {
      this.setState({
        activeClass: 'grid-righter column-filter-activated',
        headerFilter: true,
      });
    } else {
      this.setState({ activeClass: 'grid-righter', headerFilter: false });
    }
  }

  private _toggleBookmark = (): void => {
    this.setState({ bookmarkDivClass: 'bookmark-panel parent panel-on' });
  };

  private _toggleBookmarkOut = (): void => {
    this.setState({ bookmarkDivClass: 'bookmark-panel parent collapse' });
  };

  private _handleRemove = () => {
    this.setState({
      hiddenRemoveDialog: false,
    });
  };

  private onRemoveConfirm = () => {
    this.setState({
      hiddenRemoveDialog: true,
    });
    if (this.state.formData.invoiceId && this.state.formData.id) {
      this.createNew(true);
      if (getContractingUnit() && !getProject()) {
        history.push(`/CU/${getContractingUnit()}/invoice/new`);
      } else if (getContractingUnit() && getProject()) {
        history.push(`/CU/${getContractingUnit()}/project/${getProject()}/invoice/new`);
      } else {
        history.push(`/invoice/new`);
      }
    }
  };

  private onRemoveCancel = () => {
    this.setState({
      hiddenRemoveDialog: true,
    });
  };

}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortCutPaneFilters: state.invoice.invoiceShortCutdata,
    listPaneItems: state.invoice.listPaneItems,
    isDataLoaded: state.invoice.isInvoiceListLoaded,
    loadMsg: state.invoice.loadMsg,
    uid: state.invoice.uid,
    formData: state.invoice.formData,
    showProgressBar: state.invoice.showProgressBar,
    isEdit: state.invoice.isEdit,
    isChange: state.invoice.isChange,
  };
};

const mapDispatchToProps = {
  readInvoiceShortCutPaneData,
  filterInvoiceListPaneData,
  resetIsChange,
  readInvoiceDropDownData,
  readByInvoiceId,
  setUid,
  clearFormData,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(InvoiceMainLayout)),
);
